export default __webpack_public_path__ + "static/media/assignment.0b897c56.svg";